// extracted by mini-css-extract-plugin
export default {"container--empty":"CouponContainer_container--empty__zgeZi"};